export default __webpack_public_path__ + "static/media/FLECHA_AMARILLA.93ce60cb.png";